import React, { FunctionComponent, ReactNode, useState } from 'react';

// MaterialUi components
import { DataGrid, GridSelectionModel } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import LinearProgress from '@mui/material/LinearProgress';
import { Modal } from 'react-bootstrap';

// Components
import { UserModel } from '../../shared/types';
import Separator from '../Separator/Separator';

// types and constants
import { USER_TABLE_COLUMNS } from '../../shared/constants';

// API
import { userAdminApi } from '../../api/userAdminApi';

type AssignUserDialogProps = {
    openAssignUserDialog: boolean;
    handleClose: () => void;
    authorizedUsersHandler: (userIds: string[]) => void;
}

const AssignUserDialog: FunctionComponent<AssignUserDialogProps> = (props: AssignUserDialogProps) => {
    const {
        openAssignUserDialog,
        handleClose,
        authorizedUsersHandler,
    } = props;

    const [searchEmail, setSearchEmail] = useState<string>('');
    const [loadingUsers, setLoadingUsers] = useState<boolean>(false);
    const [foundUsers, setFoundUsers] = useState<UserModel[]>([]);
    const [selectedUsersId, setSelectedUsersId] = useState<string[]>([]);

    const searchEmailChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setSearchEmail(value);
    };

    const searchUser = async () => {
        setLoadingUsers(true);
        const users = await userAdminApi.getUsersByEmail(searchEmail);
        setFoundUsers(users);
    };

    const userSellectionHandler = (newSelectionModel: GridSelectionModel) => {
        setSelectedUsersId(newSelectionModel as string[]);
    };

    return (

        <div data-testid='assign-user-dialog-container' className='align-center user-table-container'>
            <Modal
                size='xl'
                show={openAssignUserDialog}
                onHide={handleClose}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Manage Authorized Users</Modal.Title>
                </Modal.Header>
                <Separator />
                <Modal.Body>
                    <div>
                        <TextField
                            id="standard-basic"
                            label="Search User"
                            variant="standard"
                            sx={{ width: 400 }}
                            value={searchEmail}
                            onChange={searchEmailChangeHandler}
                        />

                        <Button
                            color='inherit'
                            startIcon={<SearchIcon />}
                            onClick={searchUser}
                            disabled={!searchEmail}
                        />
                    </div>

                    <Separator />
                    <Separator />

                    {
                        loadingUsers && (
                            <DataGrid
                                sx={{ border: 'none' }}
                                rows={foundUsers}
                                columns={USER_TABLE_COLUMNS}
                                density='comfortable'
                                hideFooterSelectedRowCount
                                autoHeight
                                components={{
                                    LoadingOverlay: LinearProgress,
                                }}
                                loading={foundUsers.length === 0}
                                autoPageSize
                                pageSize={10}
                                checkboxSelection
                                onSelectionModelChange={userSellectionHandler}
                            />
                        )
                    }

                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant='outlined'
                        onClick={() => authorizedUsersHandler(selectedUsersId)}
                        data-testid='save-firmware'
                        disabled={selectedUsersId.length === 0}
                    >
                        Save
                    </Button>
                    <Separator direction='vertical' />
                    <Button
                        variant='outlined'
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>

            <div className='action-header'>
                <TextField
                    id="standard-basic"
                    label="Search User and assign role"
                    variant="standard"
                    sx={{ width: 400 }}
                    value={searchEmail}
                    onChange={searchEmailChangeHandler}
                />

                <Button
                    size='small'
                    color='inherit'
                    startIcon={<SearchIcon />}
                    onClick={searchUser}
                    disabled={!searchEmail}
                />
            </div>
        </div>
    )
}

export default AssignUserDialog;